import { useReducer } from 'react';
import { useApolloClient } from '@apollo/client/react/hooks';

/**
 * @name useDataFetch
 * @param query
 * @returns {{fetchData: ((function({variables: *}): Promise<void>)|*), state: S}}
 */
export const useDataFetch = ({ query }) => {
  const apolloClient = useApolloClient();

  const stateFetchReducer = (state, action) => {
    switch (action.type) {
      case 'FETCH_INIT':
        return {
          ...state,
          isLoading: true,
          isError: false,
          isSuccess: false,
        };
      case 'FETCH_SUCCESS':
        return {
          ...state,
          isSuccess: true,
          isError: false,
          isLoading: false,
          data: action.payload,
        };
      case 'FETCH_FAILURE':
        return {
          ...state,
          isError: true,
          isLoading: false,
          isSuccess: false,
        };
      default:
        throw new Error();
    }
  };

  const [state, dispatch] = useReducer(
    stateFetchReducer,
    {
      isLoading: false,
      isError: false,
      isSuccess: false,
      data: null,
    },
  );

  const fetchData = async ({ variables }) => {
    dispatch({ type: 'FETCH_INIT' });
    try {
      const { data: response } = await apolloClient.query({ query, variables });
      dispatch({ type: 'FETCH_SUCCESS', payload: response });
    } catch (error) {
      dispatch({ type: 'FETCH_FAILURE' });
    }
  };
  return { state, fetchData };
};
